import React from 'react';
export function OfferSection() {
  return <section id="oferta" className="w-full py-16 px-4 bg-brand-bg" data-id="element-100">
      {/* Closing Quote */}
      <div className="max-w-2xl mx-auto text-center space-y-4" data-id="element-101">
        <p className="text-xl md:text-2xl text-brand-muted italic font-serif" data-id="element-102">
          "La diferencia entre apostar y analizar no es talento. Es método."
        </p>
        <p className="text-brand-gold font-bold text-lg" data-id="element-103">
          — Método Sin-Tipster
        </p>
      </div>
    </section>;
}